const BASE_STYLES = {
    position: 'absolute',
    background: '#FFFFFF',
    border: '1px solid #E5E7EB',
    color: '#374151',
    pointerEvents: 'none',
    transition: 'opacity .1s ease',
    fontSize: '12px',
    zIndex: '99999',
};

const VIEWPORT_MARGIN = 10;

export function escapeHtml(value) {
    return String(value == null ? '' : value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
}

export function getTooltipEl(id, styles = {}) {
    let el = document.getElementById(id);
    if (!el) {
        el = document.createElement('div');
        el.id = id;
        Object.assign(el.style, BASE_STYLES, styles);
        document.body.appendChild(el);
    }
    return el;
}

export function hideTooltip(el) {
    el.style.opacity = '0';
}

export function positionTooltip(el, chart, tooltipModel, offset = 20) {
    const canvas = chart.canvas.getBoundingClientRect();
    const scrollX = window.pageXOffset;
    const scrollY = window.pageYOffset;
    const caretX = canvas.left + scrollX + tooltipModel.caretX;
    const caretY = canvas.top + scrollY + tooltipModel.caretY;

    el.style.opacity = '1';

    const width = el.offsetWidth;
    let left = caretX + offset;
    if (left + width > scrollX + window.innerWidth - VIEWPORT_MARGIN) {
        left = caretX - width - offset;
    }
    left = Math.max(left, scrollX + VIEWPORT_MARGIN);

    const height = el.offsetHeight;
    let top = caretY - height / 2;
    top = Math.min(top, scrollY + window.innerHeight - height - VIEWPORT_MARGIN);
    top = Math.max(top, scrollY + VIEWPORT_MARGIN);

    el.style.left = left + 'px';
    el.style.top = top + 'px';
}

export function removeTooltip(id) {
    const el = document.getElementById(id);
    if (el && el.parentNode) {
        el.parentNode.removeChild(el);
    }
}
